import React from "react"
import style from "./MessagePopup.module.css"
import GetSpace from "../../utils/space"
import defalutStyle from "../../styles/defaultPageStyle.module.css"
import { TitlePageResponsiveIconSmall } from "../Titles/Titles"
import { faCheck, faClose } from "@fortawesome/free-solid-svg-icons"
import Animate, { AnimationTypes } from "../Animate/Animate"
import ModalPortal from "../Modal/ModalPortal"
import { ButtonIcon } from "../Button/Button"

interface MessagePopupProbs {
  message: string
  title: string
  onClose: () => void
}

const MessagePopup: React.FC<MessagePopupProbs> = ({ title, message, onClose }) => {
  return (
    <ModalPortal>
      <div className={defalutStyle.overlay} style={{ zIndex: "999" }}>
        <div className={defalutStyle.alert1}>
          <TitlePageResponsiveIconSmall
            animationTypes={AnimationTypes.fadeIn}
            title={title}
            color="white"
            icon={faCheck}
            children={
              <div className={style.popupActions}>
                <ButtonIcon
                  icon={faClose}
                  sizeNumber={40}
                  onClick={onClose}
                  bgColor="#fd5050ff"
                  descriptionKey="interactionDescriptions:components.messagePopup.messagePopup.button.onClose"
                />
              </div>
            }
          />

          <GetSpace top={20} />

          <Animate type={AnimationTypes.fadeIn} duration="1.2s">
            <p className={style.message}>{message}</p>
          </Animate>

          <GetSpace top={20} />
        </div>
      </div>
    </ModalPortal>
  )
}

export default MessagePopup
